import { ParseUtcToLocalPipe } from './../../../../../../../libs/shared/src/pipes/parse-utc-to-local.pipe';
import { LocalDatePipe } from '@anihis/shared/src/pipes/local-date.pipe';
import { CommonModule } from '@angular/common';
import { Component, inject, input, output, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { MatListModule } from '@angular/material/list';
import { MatDividerModule } from '@angular/material/divider';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ReportComponent } from './tables/report/report.component';
import { DocumentsComponent } from './tables/documents/documents.component';
import { Gender } from '@anihis/core/data-access';
import { explicitEffect } from 'ngxtension/explicit-effect';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { CardHistoryStore } from './card-history.store';
import { LoadingStatus } from '../../../shared/enums/loading';
import { LoadingSkeletonComponent } from '../../../shared/component/loading-skeleton/loading-spinner.component';
import { LoadingOverlayComponent } from '../../../shared/component/loading-overlay/loading-overlay.component';
import { TranslocoModule } from '@jsverse/transloco';
// import { FormsPreviewComponent } from './tables/forms-preview/forms-preview.component';

@Component({
  selector: 'anihis-card-history',
  templateUrl: './card-history.component.html',
  styleUrls: ['./card-history.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    TranslocoModule,
    MatIconModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatCardModule,
    MatListModule,
    MatDividerModule,
    MatTabsModule,
    MatTooltipModule,
    ReportComponent,
    DocumentsComponent,
    ParseUtcToLocalPipe,
    LoadingSkeletonComponent,
    LoadingOverlayComponent,
    // FormsPreviewComponent,
    LocalDatePipe,
  ],
  providers: [CardHistoryStore],
})
export class CardHistoryComponent {
  data!: any;
  store = inject(CardHistoryStore);
  cardData = input.required<any>();
  backEvent = output();

  readonly genderType = Gender;
  isPreviewCard = signal(false);

  readonly LoadingStatus = LoadingStatus;

  constructor() {
    explicitEffect([this.cardData], ([cardData]) => {
      if (!cardData) return;
      this.store.setOwnerAnimalUids(cardData?.owner?.uid, cardData.animalUid);
    });
  }

  back() {
    this.store.back();
    this.backEvent.emit();
  }
}
